
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>add</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new place</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout mx-3 my-3 column>
            <v-flex xs6 offset-xs0>
               <v-layout row>
                <v-flex xs6>
                    <v-radio-group v-model="newPlaceType" >
                      <v-radio label="Town/suburb" value="town"></v-radio>
                      <v-radio label="State/Region" value="state"></v-radio>
                      <v-radio label="Country" value="country"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex xs6>
                  <v-text-field  v-if="showDialog" autofocus v-model="newPlace.name" label="Place Name"
                    :rules="[rules.required, rules.min]" />
                </v-flex>  
               </v-layout>
               <v-layout row v-if="newPlaceType !== 'country'">                  
                <v-flex xs12>
                  <v-autocomplete v-model="newPlace.select" :items="newPlace.places" item-text="pn" item-value="id" :label="parentTypeName"
                      :search-input.sync="npSearch" :loading="newPlace.loading" single-line  return-object>     
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <provenance-and-note v-bind:record="newPlace"/>
              <v-layout row>
                <v-flex xs12>
                  <div class="error" v-html="error"></div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn dark class="indigo darken-1" @click='createPlace' :loading="loading"><v-icon left >save_alt</v-icon> Define New Place</v-btn>
                </v-flex>
              </v-layout>         
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import PlaceService from "@/services/PlaceService" ;

export default {
  components: { Panel },
  data () {
    return {
      newPlace: {  
        name: '',        
        select: {id: -1, pn: ""},
        places: [],
        loading: false,        
        provenance: '',
        note: ''
      },
      newPlaceType: 'town',
      parentTypeName: 'State',
      npSearch: null,

      loading: false,
      
      error: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 2 || 'Minimum of 2 characters is required.'
      },
      showDialog: false
    }
  },

  methods: {
    async createPlace () {

      console.log("IN createPlace") ; 
      if (!this.$refs.form.validate()) return ;
      if ((this.newPlaceType !== 'country') && (this.newPlace.select.id <= 0)) {
        this.error = "For a town or state, you need to select a place that this new place is part of" ;
        return ;
      }

      this.error = '' ;
      try {
        this.loading = true ;
        const response = await PlaceService.create({ name: this.newPlace.name, parentId: this.newPlace.select.id, type: this.newPlaceType,
          provenance: this.newPlace.provenance, note: this.newPlace.note }) ; 
        console.log("createPlace response: " + JSON.stringify(response)) ;
        this.showDialog = false ;
        this.$renderToastInParent(this, "Place " + this.newPlace.name + " successfully created") ;
      }
      catch (err) {
        console.log("catch err:" + err) ;
        this.error = err.response.data.error 
      }
      finally {
        this.loading = false ;
      }
    },

    async placeQuerySelections (val, locp) {

      console.log("placeQuerySelections val: " + val) ;
      var parentType = null ;
      switch (this.newPlaceType) {
        case 'town':  parentType = 2 ; break ;
        case 'state': parentType = 3 ; break ;
        default: this.error = "Internal error, cant search for parent place for type " + this.newPlaceType ; return ;              
      }

      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true, parentType) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
      }
      /*
      if (locp.nextSearchFor) {
        console.log(" about to queue PQS " + locp.nextSearchFor) ;
        setTimeout(function () {
          this.placeQuerySelections(null, locp) ;
        }, 10) ;
      }
      */
    }    
  },

  watch: {
    async npSearch (val) {
      console.log("IN NP SEARCH val: " + val + ", this.newPlace.select.pn=" + this.newPlace.select.pn) ;
      if (val && val !== this.newPlace.select.pn && (val.length >= 2)) {
        this.placeQuerySelections(val, this.newPlace) ;
      }
    },
    newPlaceType (val) {
      switch (val) {
        case 'town': this.parentTypeName = 'State' ; break ;
        case 'state': this.parentTypeName = 'Country' ; break ;
        default: this.parentTypeName = 'N/A' ;
      }
      this.newPlace.places = [] ;
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PlaceCreate.vue